import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { VariavelStruct } from '@shared/services/structs/formula/variavel.struct';
import { VariaveisCursorPayload } from '@shared/components/formula/variaveis-disponiveis-dialog/variaveis-disponiveis-dialog.component';
import { VariaveisDisponiveisSectionComponent } from '@shared/components/formula/variaveis-disponiveis-section/variaveis-disponiveis-section.component';
import { ObservacaoEditorComponent } from '@shared/components/formula/observacao-editor/observacao-editor.component';

@Component({
    selector: 'app-icms-tributo-observacoes-fisco-section',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, VariaveisDisponiveisSectionComponent, ObservacaoEditorComponent],
    templateUrl: './tributo-observacoes-fisco-section.component.html',
    styleUrl: './tributo-observacoes-fisco-section.component.css',
})
export class IcmsTributoObservacoesFiscoSectionComponent {
    @Input({ required: true }) control!: FormControl;
    @Input() titulo: string = 'Informações adicionais ao fisco';
    @Input() icone: string = 'account_balance';
    @Input() placeholder: string = 'Texto das informações adicionais de interesse do fisco...';

    /** Quando true, as variáveis expandem abaixo do link (sem modal). */
    @Input() variaveisInline = false;
    /** Lista de variáveis para o modo inline. */
    @Input() variaveis: VariavelStruct[] = [];

    @Output() abrirVariaveis = new EventEmitter<VariaveisCursorPayload>();

    @ViewChild('obsEditor') editorRef?: ObservacaoEditorComponent;

    public variavelAberto = false;

    public onClicarVariaveis(): void {
        if (this.variaveis.length === 0) return;
        if (this.variaveisInline) {
            this.variavelAberto = !this.variavelAberto;
        } else {
            this.abrirVariaveis.emit({ control: this.control, selectionStart: 0, selectionEnd: 0, editor: this.editorRef });
        }
    }
}
